import { createSelector } from 'reselect';
import i18next from 'i18next';

const dashboardUsers = (state) => state.dashboardUsers;
const getRestaurants = (state) => state.businessApp.restaurants;
const getCompanies = (state) => state.budgetsApp.companies;
const getLoyaltyPrograms = (state) => state.loyaltyApp.loyaltyPrograms;
const getChains = (state) => state.businessApp.chains;
const getPOS = (state) => state.meta.posSuppliers;
const getLocale = (state) => state.locale;

export const getDashboardUsers = createSelector(
    [getLocale, dashboardUsers, getCompanies, getRestaurants, getChains, getPOS, getLoyaltyPrograms],
    (locale, users, companies, restaurants, chains, posSuppliers, loyaltyPrograms) => {

        return users.map((user) => {
            let permittedRestaurants = '';
            if (user.permissions.restaurant) {
                permittedRestaurants = i18next.t('userPermissions.allRestaurants');
                if (user.permissions.restaurant.ownersIds) {
                    permittedRestaurants = chains
                        .filter(chain => user.permissions.restaurant.ownersIds.includes(chain.id))
                        .map(chain => chain.name)
                        .join(', ');
                } else if (user.permissions.restaurant.posIds) {
                    permittedRestaurants = 'POS: ' + posSuppliers
                        .filter(pos => user.permissions.restaurant.posIds.includes(pos.id))
                        .map(pos => pos.name)
                        .join(', ');
                } else if (user.permissions.restaurant.regionsCodes) {
                    permittedRestaurants = 'Regions: ' + user.permissions.restaurant.regionsCodes.join(', ');
                } else if (user.permissions.restaurant.ids) {
                    permittedRestaurants = restaurants
                        .filter(rest => user.permissions.restaurant.ids.includes(rest.id))
                        .map(rest => rest.name)
                        .join(', ');
                }
            }

            let permittedCompanies = '';
            if (user.permissions.company) {
                permittedCompanies = i18next.t('userPermissions.allCompanies');
                if (user.permissions.company.ids) {
                    permittedCompanies = companies
                        .filter(comp => user.permissions.company.ids.includes(comp.id))
                        .map(comp => comp.name)
                        .join(', ');
                }
            }

            let permittedLoyaltyPrograms = '';
            if (user.permissions.loyalty) {
                permittedLoyaltyPrograms = i18next.t('userPermissions.allLoyalties');
                if (user.permissions.loyalty.ids) {
                    permittedLoyaltyPrograms = loyaltyPrograms
                        .filter(loyalty => user.permissions.loyalty.ids.includes(loyalty.id))
                        .map(loyalty => loyalty.name)
                        .join(', ');
                }
            }

            return {
                ...user,
                permittedRestaurants,
                permittedCompanies,
                permittedLoyaltyPrograms
            };
        });
    }
);

